export enum ElementType {
    LOGO = 'LOGO',
    TITLE = 'TITLE',
    APP_TITLE = 'APP_TITLE',
    FONT_COLOR = 'FONT_COLOR',
    BACKGROUND_COLOR = 'BACKGROUND_COLOR',
    FAVICON = 'FAVICON'
}


export interface LayoutResponse {
    id: number,
    elementType: string,
    elementHtml: string,
}


export enum StatusEnum {
    APPROVED = 'APPROVED',
    DECLINED = 'DECLINED'
}
export interface StateResponse {
    status: StatusEnum | undefined,
    code: string | undefined,
}  